module.exports = __webpack_public_path__ + "img/15.10.pH.df43f1c6.png";